import React, { useEffect, useState } from "react";
import { sumArray } from "./gloFunc";
import './mCalendar.scss';
import SDAddMemo from "./sdAddMemo";
import SDFinance from "./sdFinance";

function MCalendar (props) {
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth());
  const [cData, setCData] = useState([]);
  const [memo, setMemo] = useState([]);
  const [memorial, setMemorial] = useState([]);
  const [monthIn, setMonthIn] = useState(0);
  const [monthOut, setMonthOut] = useState(0);

  useEffect(() => {
    initCalendar();
    checkMemo();
    IOReset();
    checkMemorial();
  }, [month, year, props.memo, props.memorial, props.todoList, props.userMC]);

  function checkMemo() {
    let tmo = props.memo.filter(m => m.startYear === year && m.startMonth === month)
    setMemo(tmo);
  }

  function checkMemorial() {
    let tme = props.memorial.filter(m => m.year === year && m.month === month);
    setMemorial(tme);
  }

  function IOReset () {
    if (!props.finance || props.finance.length === 0) return;
    let tfin = props.finance.filter(m => m.year === year && m.month === month);
    let tfinIn = tfin.filter(f => f.io === 'in').map(f => f.value);
    let tfinOut = tfin.filter(f => f.io === 'out').map(f => f.value);
    setMonthIn(tfinIn && tfinIn.length > 0 ? sumArray(tfinIn) : 0);
    setMonthOut(tfinOut && tfinOut.length > 0 ? sumArray(tfinOut) : 0);
  }

  function initCalendar () {
    let tmpCD = [];
    let initDate = new Date(year, month, 1);
    let fdate = new Date(initDate.getFullYear(), initDate.getMonth(), 1);
    setMonth(fdate.getMonth());
    setYear(fdate.getFullYear());
    let ldate = new Date(fdate.getFullYear(), fdate.getMonth() + 1, 0);       
    let mLength = (ldate - fdate) / (1000 * 60 * 60 * 24);
    let weekLenght = Math.ceil((fdate.getDay() + 1 + mLength) / 7);
    let startDate = new Date(fdate.getFullYear(), fdate.getMonth(), 1 - fdate.getDay());
    for (let w = 0; w < weekLenght; w++) {
      for (let d = 0; d < 7; d++) {
        tmpCD.push({
          year: startDate.getFullYear(),
          month: startDate.getMonth(),
          day: startDate.getDate(),
          date: startDate,
          memo: [],
        })
        startDate = new Date(startDate.setDate(startDate.getDate() + 1));
      }
    }
    setCData(tmpCD);
  }

  function changeMonth(e) {
    setMonth(month => month + e);
  }

  function changeYear(e) {
    setYear(year => year + e)
  }

  function selectDay(e, d) {
    if (e.target.className.split(' ').find(d => d === 'day' || d === 'memo')) {
      setYear(d.year);
      setMonth(d.month);
      props.selectDay(e, d);
    }
  }

  return <div className="mCalendar">
    <div className="ymb">
      <div className="btn" onClick={() => changeYear(-1)}>{'<'}</div>
      <div>{year}</div>
      <div className="btn" onClick={() => changeYear(1)}>{'>'}</div>
      <div className="btn" onClick={() => changeMonth(-1)}>{'<'}</div>
      <div>{month + 1}</div>
      <div className="btn" onClick={() => changeMonth(1)}>{'>'}</div>
      <div className="min">月收入:{`${monthIn}`}</div>
      <div className="mout">月支出:{`${monthOut}`}</div>
      <div className="calplus">
        <SDAddMemo inputDate={true} mcHistory={props.mcHistory} ></SDAddMemo>
      </div>
    </div>
    <div className="MCBody">
      {cData.map((d, index) => {
        let finance = props.finance.filter(m => m.year === d.year && m.month === d.month && m.day === d.day);
        let nMemo = memo.filter(m => m.startYear === d.year && m.startMonth === d.month && m.startDay === d.day);
        let nMemorial = memorial.filter(m => m.year === d.year && m.month === d.month && m.day === d.day)
        let cn = ['title'];
        switch (index % 7)
        {
            case 0: 
                cn.push('sunday');
                break;
            case 6: 
                cn.push('saturday');
                break;
            default:
                break;
        }

        let cdn = ['day']
        if (d.month !== month) {
          cdn.push('notThisMonth');
        }

        if (nMemorial && nMemorial.length > 0) {
          cdn.push('birth');
        }

        if (props.userMC) {
          let mcTarget = props.userMC.target.filter(m => m.year === d.year && m.month === d.month && m.day === d.day);
          let mcWarning = props.userMC.warning.filter(m => m.year === d.year && m.month === d.month && m.day === d.day);
          if (mcTarget && mcTarget.length > 0) {
            cdn.push('mcTarget');
          }

          if (mcWarning && mcWarning.length > 0) {
            cdn.push('mcWarning');
          }
        }

        return <div className={cdn.join(' ')} key={`${d.year}${d.month}${d.day}`} onClick={e => selectDay(e, d)}>
          <div className={cn.join(' ')}>
            <div className="daynum">{`${d.day}`}</div>
            <SDFinance day={d.day} month={d.month} year={d.year} data={finance}></SDFinance>
            <SDAddMemo day={d.day} month={d.month} year={d.year}></SDAddMemo>
          </div>
          <div className="memoList">
          {
            nMemo.map((m, i) => {
              return <div className="memo" key={m.journeyID}>{m.title}</div>
            })
          }
          {
            nMemorial.map((m, i) => {
              return <div className="memo" key={m.memorialID}>{m.title}</div>
            })
          }
          </div>
        </div>
      })}
    </div>
  </div>
}


export default MCalendar;